import React, {useState} from "react";
import database from '../firebase';
import './EnrollPhone.css';



const db = database.firestore();

export default function EnrollPhone() {
    const [Name, setName] = useState('');
    const [Email, setEmail] = useState('');
    const [Password, setPassword] = useState('');
    const [Password_, setPassword_] = useState(''); 
    const [English, setEnglish] = useState(true);

    const handleSumbit = (e) =>{
        e.preventDefault();
        
        if (Password !== Password_){
            alert ("密码不一致!")
        }else{
            database.auth().createUserWithEmailAndPassword(Email,Password)
            .then(()=>{
                var user = database.auth().currentUser;
                
                db.collection("users").doc(user.uid).set({
                    uid: user.uid,
                    personalinfor:{
                        Name: Name,
                        Email: Email,
                        ProfileImg: "default",
                        Intro:""
                    }
                }).then(()=>{
                    db.collection("uids").doc(Email).set({
                        uid: user.uid,
                        Email: Email,
                    }).then(()=>{
                    }).catch((err)=>{
                        alert(err.message);
                    });
                }).catch((err)=>{
                    alert(err.message);
                });

                db.collection("users").doc(user.uid).collection("Game").doc("Puzzle").set({
                    Image: "",
                    col: 0,
                    level: "",
                    row: 0
                })
                    
                setName("");
                setEmail("");
                setPassword("");
                setPassword_("");

            }).then(()=>{
                alert("Account has been created! 帐号已完成创建")
            }).catch((err)=>{
                alert(err);
            });
        }
    }

    const ChangeToChinese =()=>{
        setEnglish(false);
    }

    const ChangeToEnglish =()=>{
        setEnglish(true);
    }

    return (
        <div> 
            {English?(
                <div className="EnrollPhone">
                <h1>Enroll an Account </h1> 
                <div onClick={ChangeToChinese}> <h3>中文</h3></div>
                <form onSubmit={handleSumbit}>
                    <label style={{marginTop:'20px'}}>Name:</label>
                    <input type="text" required value={Name}
                        placeholder = "    Name" style={{marginTop:'-23px'}}
                        onChange={(e) => setName(e.target.value)}
                    />
                    
                    <label style={{marginTop:'15px'}}>Email: </label>
                    <input type="text" required value={Email}
                        placeholder = "    Email"  style={{marginTop:'-23px'}}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <label style={{marginTop:'15px'}}>Password:</label>
                    <input type="password" required value={Password}
                        placeholder = "    Password" style={{marginTop:'-23px'}}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <label style={{marginTop:'15px'}}>Confirm Password:</label>
                    <input type="password" required value={Password_}
                        placeholder = "    Confirm"  style={{marginTop:'-23px'}}
                        onChange={(e) => setPassword_(e.target.value)}
                    />
                    <button type="submit"> <h6>Enroll</h6></button><b/> 
                </form>
                </div>
            ):(
                <div className="EnrollPhone">
                <h1>注册帐号</h1> 
                <div onClick={ChangeToEnglish}> <h3>English</h3></div>
                <form onSubmit={handleSumbit}>
                    <label style={{marginTop:'20px'}}>名字:</label>
                    <input type="text" required value={Name}
                        placeholder = "    用户名" style={{marginTop:'-23px'}}
                        onChange={(e) => setName(e.target.value)}
                    /><br/>
                    
                    <label style={{marginTop:'15px'}}>邮箱:</label>
                    <input type="text" required value={Email}
                        placeholder = "    邮箱" style={{marginTop:'-23px'}}
                        onChange={(e) => setEmail(e.target.value)}
                    /><br/>

                    <label style={{marginTop:'15px'}}>密码:</label>
                    <input type="password" required value={Password}
                        placeholder = "    密码" style={{marginTop:'-23px'}}
                        onChange={(e) => setPassword(e.target.value)}
                    /><br/>

                    <label style={{marginTop:'15px'}}>确认密码:</label>
                    <input type="password" required value={Password_}
                        placeholder = "    确认密码" style={{marginTop:'-23px'}}
                        onChange={(e) => setPassword_(e.target.value)}
                    /><br/> 
                    <button type="submit"> <h6>注册</h6></button><b/> 
                </form>
                </div>
            )

            }
        </div>


        
    );
     
}